import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m33.66 36.413 5.28 5.3c.864.868 2.16-.433 1.296-1.3l-33-33.127c-.864-.867-2.16.434-1.296 1.301l4.354 4.371C7.762 14.665 5.44 16.9 3.328 19.66a6.46 6.46 0 0 0-.004 7.843c5.484 7.181 12.4 10.8 20.68 10.8 3.454 0 6.674-.63 9.655-1.89Zm-1.41-1.415-3.52-3.532a9.102 9.102 0 0 1-4.725 1.316c-5.063 0-9.167-4.12-9.167-9.202a9.19 9.19 0 0 1 1.31-4.744l-4.531-4.55c-2.477 1.615-4.755 3.778-6.835 6.495a4.615 4.615 0 0 0-.003 5.603C9.925 33.12 16.31 36.462 24.005 36.462c2.942 0 5.689-.488 8.244-1.464ZM17.494 20.187a7.35 7.35 0 0 0-.824 3.393c0 4.065 3.284 7.361 7.334 7.361a7.277 7.277 0 0 0 3.38-.826l-9.89-9.928Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.893 11.501c.174.478.7.724 1.175.55 2.47-.902 5.114-1.354 7.937-1.354 7.679 0 14.06 3.344 19.215 10.087a4.615 4.615 0 0 1 .003 5.597c-1.844 2.418-3.847 4.397-6.01 5.94a.922.922 0 0 0-.216 1.284.914.914 0 0 0 1.278.217c2.317-1.655 4.452-3.763 6.403-6.322a6.46 6.46 0 0 0-.004-7.836C39.182 12.478 32.27 8.857 24.004 8.857c-3.033 0-5.889.488-8.563 1.465a.921.921 0 0 0-.548 1.18Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.593 17.062a7.274 7.274 0 0 1 3.723-.837 5.536 5.536 0 0 0-.311 1.834c0 3.049 2.462 5.52 5.5 5.52.63 0 1.247-.107 1.826-.311a7.35 7.35 0 0 1-.77 3.614.922.922 0 0 0 .407 1.235.915.915 0 0 0 1.23-.409 9.27 9.27 0 0 0 .776-6.031.916.916 0 0 0-1.411-.571 3.635 3.635 0 0 1-2.058.633 3.674 3.674 0 0 1-3.667-3.68c0-.749.222-1.461.631-2.066a.921.921 0 0 0-.569-1.418 9.174 9.174 0 0 0-6.162.859.922.922 0 0 0-.384 1.243c.236.45.79.622 1.239.385Z",
    fill: "currentColor"
  }));
};

var SvgVisibleOff = styled(SvgComponent).withConfig({
  displayName: "VisibleOff__SvgVisibleOff",
  componentId: "sc-6yteqg-0"
})(["", " ", ""], size, color);
export default SvgVisibleOff;